module.exports = "<div class=\"mat-app-background basic-container\" *ngIf=\"currentUser\">\n  <app-sidenav>loading</app-sidenav>\n</div>\n"